import { Badge as MantineBadge, type MantineColor } from "@mantine/core";
import type { ReactNode } from "react";

interface BadgeProps {
  children?: ReactNode;
  color?: MantineColor;
  label?: string;
  variant?: string;
}

/**
 * Badge renders the {% badge %} tag as an inline Mantine `Badge`. The body (or
 * `label`) is the text; `color` and `variant` style the pill.
 *
 * `component="span"` because this tag is INLINE: Markdoc wraps a paragraph's inline
 * content in a `<p>`, and Mantine's Badge is a `<div>` by default, so the default put a
 * block element inside a paragraph. That is invalid HTML, and it is not a cosmetic
 * complaint. The parser closes the `<p>` at the `<div>`, so the prerendered page and the
 * hydrated one disagree about the tree, which React reports as a hydration error and a
 * browser resolves by breaking the sentence around the badge into pieces.
 */
export const Badge = ({ children, color, label, variant }: BadgeProps) => (
  <MantineBadge color={color} component="span" variant={variant}>
    {children ?? label}
  </MantineBadge>
);
